'use strict';

module.exports = function(Handlebars) {
  Handlebars.registerHelper('add', function(num1, num2) {
    return parseFloat(num1) + parseFloat(num2);
  });

  Handlebars.registerHelper('minus', function(num1, num2) {
    return parseFloat(num1) - parseFloat(num2);
  });

  Handlebars.registerHelper('min', function(num1, num2) {
    return Math.min(num1, num2);
  });
};



// WEBPACK FOOTER //
// ./assets/js/handlebars-helpers/math.js